import React from 'react';
import { 
  ShieldCheck, 
  DollarSign, 
  CheckCircle2, 
  XCircle, 
  HelpCircle 
} from 'lucide-react';

export const InsuranceComparatorPage: React.FC = () => {
  const policies = [
    { provider: 'IDFraud.au Cyber Shield (Included)', limit: '$50,000 AUD', coversTheft: true, coversRansom: true, excess: '$0', note: 'Integrated with 24/7 dark web surveillance & IDCARE support.' },
    { provider: 'Generic Home & Contents Add-on', limit: '$10,000 AUD', coversTheft: false, coversRansom: false, excess: '$500', note: 'Strict exclusions for unforced credential theft and social engineering.' },
    { provider: 'Commercial Executive Cyber Policy', limit: '$100,000 AUD', coversTheft: true, coversRansom: true, excess: '$2,500', note: 'Expensive annual retainers aimed at large corporate boards.' }
  ];

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-8">
      <div className="text-center space-y-2">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-950 text-blue-300 text-xs font-bold border border-blue-800">
          <ShieldCheck className="w-3.5 h-3.5" />
          <span>AUSTRALIAN INSURANCE INDUSTRY BENCHMARK</span>
        </div>
        <h1 className="text-3xl font-extrabold text-white">Personal Cyber Insurance Policy Comparator</h1>
        <p className="text-xs text-slate-400 max-w-xl mx-auto">
          Compare personal cyber insurance policies available in Australia to understand sub-limits, exclusions, and true recovery value.
        </p>
      </div>

      <div className="space-y-4">
        {policies.map((p, idx) => (
          <div key={idx} className="bg-slate-900 border border-slate-800 rounded-3xl p-6 shadow-xl space-y-3 text-xs">
            <div className="flex items-center justify-between border-b border-slate-800 pb-3">
              <span className="font-bold text-white text-sm">{p.provider}</span>
              <span className="text-emerald-400 font-mono font-bold">{p.limit} Coverage</span>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 text-slate-300">
              <div>Excess / Deductible: <span className="font-bold text-white font-mono">{p.excess}</span></div>
              <div>Identity Theft Coverage: <span className="font-bold text-emerald-400">{p.coversTheft ? 'YES' : 'NO'}</span></div>
              <div>Social Engineering Cover: <span className="font-bold text-emerald-400">{p.coversRansom ? 'YES' : 'NO'}</span></div>
            </div>
            <p className="text-slate-400 text-[11px] pt-1">{p.note}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
